import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsWin extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        let isWin = GameState.currentGameHasSymbolWinResults();

        if (record instanceof SpinRecord) {
            if (record.freespinsWon > 0) {
                isWin = true;
            }
        }

        return isWin ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/decisions/is-win.ts